<template>
  <div class="container faq">
    <h2>FAQ</h2>
    <v-expansion-panels>
      <v-expansion-panel
        class="faq-pannel"
        v-for="(question, index) in faqs"
        v-bind:key="'faq-' + index"
      >
        <v-expansion-panel-title
          ><h3>{{ question.title }}</h3></v-expansion-panel-title
        >
        <v-expansion-panel-text
          ><div v-html="question.text"></div
        ></v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  name: "FAQComponents",
  props: {
    faq: {
      type: Array,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      faqs: null,
    };
  },
  created() {
    this.faqs = this.faq ? this.faq : this.fallbackFaq;
  },
  computed: {
    fallbackFaq() {
      let faq = [
        {
          title: "Change payment method",
          text:
            "If you are subscribed and paying through our website, use these steps to change your payment method.\n" +
            "1. Login to your FlixLatino account\n" +
            "2. Select your profile\n" +
            "3. Click on the downward arrow on the top right-hand side of the screen\n" +
            '4. Click "Choose another way to pay"\n' +
            "5. Choose your payment method and provide the payment information requested\n" +
            " \n" +
            "Note: This method is only supported for users paying directly via FlixLatino.com. Users billing through the App Store, Google Play, Amazon Fire, Verizon, or Roku will have to update their payment method with that provider directly.",
        },
        {
          title: "How to cancel a subscription on the FlixLatino.com website?",
          text: "Login to your FlixLatino account on our website Click on the down arrow on the top right corner of the screen\n Click on Account Click on Cancel membership",
        },
      ];

      if (this.$i18n.locale === "es") {
        faq = [
          {
            title: "Cambiar su método de pago",
            text:
              "Si estás suscrito y pagas a través de nuestra página web, sigue estos pasos para cambiar tu método de pago.\n" +
              " \n" +
              "1. Inicia sesión en tu cuenta FlixLatino\n" +
              " \n" +
              "2. Selecciona tu perfil\n" +
              " \n" +
              "3. Haz clic en la flecha apuntando hacia abajo en la parte superior derecha de la pantalla\n" +
              " \n" +
              '4. Haz clic en "Elegir otra forma de pago"\n' +
              " \n" +
              "5. Elije tu método de pago y proporciona la información de pago solicitada\n" +
              " \n" +
              " \n" +
              "Nota: Este método sólo es funciona para suscriptores que pagan directamente a través de FlixLatino.com. Los usuarios que facturen a través de App Store, Google Play, Amazon Fire, Verizon o Roku deberán actualizar su método de pago con ese proveedor directamente.",
          },
          {
            title:
              "¿Cómo cancelar mi suscripción si me registre por la web FlixLatino.com?",
            text:
              "Inicia una sesión de FlixLatino en nuestra página web\n" +
              "Haz clic en la flecha que apunta hacia abajo ubicada en la esquina derecha de arriba de tu pantalla\n" +
              'Haz clic en "Cuenta"\n' +
              'Haz clic en "Cancelar membresía"\n',
          },
        ];
      }
      return faq;
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/colors";
.faq {
  h2 {
    margin: 1.5em auto;
    font-size: 68px;
    font-weight: 700;
    line-height: 84px;
  }
  margin-bottom: 1.5em;
  text-align: center;
  .faq-pannel {
    border: 1px solid $washed-white;
    background: #131a29;
    backdrop-filter: blur(16px);
    margin-bottom: 0.5em;
    border-radius: 14px !important;
    &.v-expansion-panel,
    &.v-expansion-panel--active,
    &.v-expansion-panel--before-active,
    &.v-expansion-panel--after-active {
    }
    button.v-expansion-panel-title {
      border-radius: 14px;
      & > h3 {
        font-size: 1.7em;
      }
      &:hover {
        .v-expansion-panel-title__overlay {
          background: $washed-white;
        }
      }
      &.v-expansion-panel-title--active {
        .v-expansion-panel-title__overlay {
          background: $washed-white;
          border-bottom-right-radius: 0;
          border-bottom-left-radius: 0;
        }
      }
      .v-expansion-panel-title__icon {
        background: url("@/assets/img/plus-sign.svg") no-repeat center center;
      }
      &.v-expansion-panel-title--active {
        .v-expansion-panel-title__icon {
          background: url("@/assets/img/minus-sign.svg") no-repeat center center;
        }
      }
    }
  }
  .v-expansion-panel-text__wrapper {
    text-align: left;
  }
  .v-expansion-panel--active > .v-expansion-panel-title {
    min-height: auto;
  }
  .v-expansion-panels,
  .v-expansion-panels:not(.v-expansion-panels--variant-accordion)
    > :not(:first-child):not(:last-child):not(.v-expansion-panel--active):not(
      .v-expansion-panel--before-active
    ),
  .v-expansion-panels:not(.v-expansion-panels--variant-accordion)
    > :not(:first-child):not(:last-child):not(.v-expansion-panel--active):not(
      .v-expansion-panel--after-active
    ),
  .v-expansion-panels:not(.v-expansion-panels--variant-accordion)
    > :first-child:not(:last-child):not(.v-expansion-panel--active):not(
      .v-expansion-panel--before-active
    ),
  .v-expansion-panels:not(.v-expansion-panels--variant-accordion)
    > :last-child:not(:first-child):not(.v-expansion-panel--active):not(
      .v-expansion-panel--after-active
    ) {
    border-radius: 14px !important;
  }

  @media (min-width: 1920px) {
    font-size: 0.8vw;
    &.container{
      max-width: none;
      width: 65%;
    }
  }
}
.mdi-chevron-up::before,
.mdi-chevron-down::before {
  content: "" !important;
}
</style>
